/* unplugin-vue-components disabled */import script from "./EditAcademicProject.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAcademicProject.vue?vue&type=script&setup=true&lang=js"

import "./EditAcademicProject.vue?vue&type=style&index=0&id=3ae530e5&lang=scss&scoped=true"
import "./EditAcademicProject.vue?vue&type=style&index=1&id=3ae530e5&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae530e5"]])

export default __exports__